interface State {
  isSearchProductList: boolean;
  isSearchJudgementList: boolean;
}

export default {
  namespaced: true,
  state: {
    isSearchProductList: false,
    isSearchJudgementList: false
  },
  mutations: {
    SET_SEARCHPRODUCTLIST(state: State, isSearch: boolean): void {
      state.isSearchProductList = isSearch;
    },
    SET_SEARCHJUDGEMENTLIST(state: State, isSearch: boolean): void {
      state.isSearchJudgementList = isSearch;
    }
  },
  getters: {
    getIsSearchProductList(state: State): boolean {
      return state.isSearchProductList;
    },
    getIsSearchJudgmentList(state: State): boolean {
      return state.isSearchJudgementList;
    }
  }
};
